import { Outlet, Link, useLocation } from "react-router-dom";

const Layout = () => {

    const location = useLocation();

    return (
    <>
    <div className="container overflow-hidden">
        <div className="row justify-content-lg-center">
            <div className="col-lg-8 px-0">
                <header className="border border-dark bg-black">
                    <div className="position-relative h-100 progress-bar-striped bg-dark" style={{"min-height": "30px"}}>
                        {/*<img className="img-fluid col-12" alt="lam.sg" src="/images/banner2.png" />*/}
                        <h5 className="my-0"><span className="badge bg-success text-dark position-absolute progress-bar-striped bg-warning bottom-0 end-0">Powered by ReactJS</span></h5>
                    </div>
                    <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
                        <div className="container-fluid">
                            <a className="navbar-brand" href="#">YongXian's Homepage</a>

                            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarMain" aria-controls="navbarMain" aria-expanded="false" aria-label="Toggle navigation">
                                <span className="navbar-toggler-icon"></span>
                            </button>
                            
                            <div className="collapse navbar-collapse" id="navbarMain">
                                <ul className="navbar-nav">
                                    <li className="nav-item"><Link className={"nav-link " + (location.pathname === "/about" ? "active" : "")} to="/about">Home</Link></li>
                                    <li className="nav-item"><Link className={"nav-link " + (location.pathname === "/project" ? "active" : "")} to="/project">Projects</Link></li>
                                    <li className="nav-item"><Link className={"nav-link " + (location.pathname === "/experience" ? "active" : "")} to="/experience">Experience</Link></li>
                                    <li className="nav-item"><Link className={"nav-link " + (location.pathname === "/credential" ? "active" : "")} to="/credential">Credentials</Link></li>
                                    <li className="nav-item"><Link className={"nav-link " + (location.pathname === "/contact" ? "active" : "")} to="/contact">Contact</Link></li>
                                </ul>
                            </div>
                        </div>
                    </nav>
                </header>
                
                <Outlet />
                
                <footer className="progress-bar-striped bg-dark font-monospace text-light text-center small rounded-pill mt-2 py-1">
                    Lam YongXian &#169; 2026. All Rights Reserved.
                </footer>
            </div>
        </div>
    </div>
    </>
    )
};

export default Layout;
